export default __webpack_public_path__ + "locales/lo-LA/CreateEditRoomDialog.json?hash=429a960d328de6cdd701ac7b59365f6e";